import { createSelector } from 'reselect'

// eslint-disable-next-line
export const getPlot = createSelector(
  [
    state => state.plot,
  ],
  plot => plot,
)



// WEBPACK FOOTER //
// ./src/modules/plot/selectors.js